export const SAMPLE_CONSTANTS = {
    DEFAULT_SAMPLE_RATE: 100,
    MAXIMUM_SAMPLE_RATE: 1001,
    MAXIMUM_HEATMAP_SAMPLE_RATE: 10000,
};
